import { api } from 'shared/api'
import { AnalyticsApiSchemas } from 'shared/api/requests/analytics/schemas'

export const AnalyticsApi = {
  getSummary: api.account.createGet({
    url: '/analytics/summary',
    schemas: AnalyticsApiSchemas.getSummary,
    scope: 'analytics',
    section: null,
  }),
  getContentStatistics: api.account.createGet({
    url: '/analytics/content',
    schemas: AnalyticsApiSchemas.getContentStatistics,
    scope: 'analytics',
    section: null,
  }),
}
